export default {
    props: ['customer'],
    components: {}
};
